module.exports = __webpack_public_path__ + "static/media/JS.a1f0114e.svg";